import { InjectionToken } from '@angular/core';
import { IEnvironmentVariables } from '@env/IEnvironment';

export const API_URL = new InjectionToken<string>('API_URL');
export const API_PLATFORM_URL = new InjectionToken<string>('API_PLATFORM_URL');

export function apiUrlFactory(envConfig: IEnvironmentVariables): string {
  return `${envConfig.apiUrl}/api/`;
}

export function apiPlatformUrlFactory(envConfig: IEnvironmentVariables): string {
  return `${envConfig.platformApiUrl}/api/`;
}
